// ============================================================================
// FILE: src/modules/ticket/components/performance/charts/MTTRTrendChart.jsx
// PURPOSE:
//   MTTR / MTTA efficiency snapshot
// ============================================================================

import React from "react";

export default function MTTRTrendChart({ mttr, mtta }) {
  const mttrVal = Number(mttr) || 0;
  const mttaVal = Number(mtta) || 0;
  const max = Math.max(mttrVal, mttaVal, 1);

  return (
    <div
      style={{
        marginTop: 24,
        padding: 16,
        borderRadius: 12,
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
      }}
    >
      <h4 style={{ marginBottom: 12 }}>Resolution & Assignment Efficiency</h4>

      <div style={{ display: "flex", gap: 24, alignItems: "flex-end" }}>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              height: `${(mttrVal / max) * 100}px`,
              width: 40,
              background: "#f59e0b",
              borderRadius: 6,
            }}
          />
          <div style={{ marginTop: 6, fontSize: 12 }}>MTTR</div>
          <strong>{mttrVal > 0 ? `${Math.round(mttrVal / 60)} min` : "0"}</strong>
        </div>

        <div style={{ textAlign: "center" }}>
          <div
            style={{
              height: `${(mttaVal / max) * 100}px`,
              width: 40,
              background: "#8b5cf6",
              borderRadius: 6,
            }}
          />
          <div style={{ marginTop: 6, fontSize: 12 }}>MTTA</div>
          <strong>{mttaVal > 0 ? `${Math.round(mttaVal / 60)} min` : "0"}</strong>
        </div>
      </div>

      <div style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>
        Average values for the selected period (historical trend coming soon).
      </div>
    </div>
  );
}
